import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { useCallback } from 'react';

function useRedirect() {
  const dispatch = useDispatch();
  return useCallback(
    (path, state) => {
      dispatch(push(path, state));
    },
    [dispatch],
  );
}

export default useRedirect;
